<template>
  <v-layout
    :row="orientation === 'horizontal'"
    :column="orientation === 'vertical'"
    :justify-end="horizontalAlignment === 'right'"
  >
    <v-tooltip top v-for="(button, index) in activeButtons" :key="button.id">
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          @click="$emit(button.id)"
          x-small
          text
          icon
          :color="button.color ? button.color : 'accent'"
          :disabled="button.disabled"
          class="ma-0"
          :class="{
            'not-first-btn': !isFirstButton(index),
            'not-last-btn': !isLastButton(index)
          }"
        >
          <v-icon>{{ button.icon }}</v-icon>
        </v-btn>

        <v-divider
          v-if="activeButtons.length > 1 && !isLastButton(index)"
          :vertical="orientation === 'horizontal'"
          inset
        />
      </template>

      <span>{{ button.tooltip }}</span>
    </v-tooltip>
  </v-layout>
</template>

<script>
export default {
  name: "ListEditionToolbar",

  props: {
    buttons: {
      type: Array,
      required: true
    },

    orientation: {
      type: String,
      default: "horizontal"
    },

    horizontalAlignment: {
      type: String,
      default: "left"
    }
  },

  computed: {
    activeButtons() {
      return this.buttons.filter(button => button.active);
    }
  },

  methods: {
    isFirstButton(index) {
      return index === 0;
    },

    isLastButton(index) {
      return index === this.activeButtons.length - 1;
    },

    getTooltipText(buttonID, defaultText) {
      let prop = this[buttonID + "Tooltip"];
      return prop ? prop : this.$i18n.t(defaultText);
    }
  }
};
</script>

<style scoped>
.v-btn {
  min-width: unset;
  height: 30px;
  padding: 0 8px;
}

.v-btn.not-first-btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.v-btn.not-last-btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_Molecules/ListEditionToolbar.vue